import { useCallback } from 'react';

import { useLoggedInUserPermissions } from '~/components/Auth';
import { AppModules } from '~/services/Permissions';

type UseInstanceConfigsOutput = {
  isModuleEnabled: (module: AppModules) => boolean;
};

export const useInstanceConfigs = (): UseInstanceConfigsOutput => {
  const { enabledModules } = useLoggedInUserPermissions();

  // TODO: Include way to check other instance config values

  const isModuleEnabled = useCallback(
    (module: AppModules) => {
      return enabledModules?.includes(module) || false;
    },
    [enabledModules],
  );

  return {
    isModuleEnabled,
  };
};
